<div class="page__section _flat l-wrapper">
  <div class="menu-head">
    <ng-template #bannerView></ng-template>
  </div>

  <ng-container *ngIf="(loadingMenuStatus$ | async) === false; else loader">
    <ng-container *ngIf="(categories$ | async) as menuGroups; else emptyMessage">
      <ng-container *ngIf="menuGroups.length; else emptyMessage">
        <div class="page__nav">
          <app-menu-nav [menuGroups]="menuGroups"></app-menu-nav>
        </div>
        <router-outlet></router-outlet>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #emptyMessage>
    <span class="h4" i18n="@@EmptyDataMessage">So far there is nothing</span>
  </ng-template>
</div>

<ng-template #loader>
  <div class="spinner-wrap">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</ng-template>
